<template>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="exampleModalLabel">Order Reciept</h3>
                <button type="button" ref="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                    <div class="card">
  <div class="card-body mx-4">
        <div class="container">
        <p class="my-4" style="font-size: 30px;">Checkout Order</p>
        <div class="row">
            <ul class="list-unstyled">
            <li class="text-muted mt-1 h4"><span class="text-black h4">Invoice:</span> {{order.readable_ID}}</li>
            </ul>
            <hr>
          
    <div class="row" v-for="(item, index) in $props.order.item_list" :key="index">
            <div class="col-9">
            <p>{{item.numberOfDrinks + ' x ' + item.name}} <span style="color: grey;">{{ ' ($' + item.cost_with_tax.toFixed(2) + ')' }}</span></p>
             <p v-if="item.specialInstructions" class="ms-4"><b>Special Instructions: </b></p>
             <p v-if="item.specialInstructions" class="ms-4">{{item.specialInstructions}}</p>
              <div v-if="item.additionalInfo" class="ms-4">
                <p><b>Additional Info: </b></p>
                <div 
                  v-for="(info, key) in item.additionalInfo" 
                  :key="key" 
                  class="additional-info margin-xl-left-header"
                >
                  <p 
                    v-for="(dataItem, subKey) in info" 
                    :key="subKey" 
                    class="additional-item-text"
                  >
                    <span class="bold-text">{{ subKey }}</span> - ${{ parseFloat(dataItem.cost).toFixed(2) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-3">
            <p class="float-end">$ {{ getFullItemCost(item).toFixed(2) }}
            </p>
            </div>
            <hr v-if="index!=$props.order.item_list.length-1">
        </div>
       

            <hr style="border: 2px solid black;">
        </div>
        <div class="row text-black">

          <div class="col-xl-12">
            <p class="float-end ">Sub Total: ${{getSubTotal().toFixed(2)}}
            </p>
            </div>

            <div v-if="$props.order.payment_ID" class="col-xl-12">
            <p class="float-end ">Platform Fee: $ {{platformFee(order.total_cost)}}
            </p>
            </div>

            <div v-if="$props.order.stripe_tip_amount" class="col-xl-12">
            <p class="float-end ">Tip: $ {{toDollarAmount(order.stripe_tip_amount)}}
            </p>
            </div>

            <div class="col-xl-12">
            <p class="float-end fw-bold">Total: $ {{toDollarAmount(order.total_cost)}}
            </p>
            </div>
            <hr style="border: 2px solid black;">
        </div>


        </div>
        <div v-if="$props.order.acceptance_notes && $props.order.acceptance_notes.trim() !== ''" class="form-group">
        <h4>Acceptance Notes:</h4>
        <textarea disabled class="notes-box" v-model="$props.order.acceptance_notes"></textarea>
        </div>

        <!-- Cancel Reason -->
        <div v-if="$props.order.cancel_reason && $props.order.cancel_reason.trim() !== ''" class="form-group">
        <h4>Cancel Reason:</h4>
        <textarea disabled class="notes-box" v-model="$props.order.cancel_reason"></textarea>
        </div>
    </div>

</div>

            </div>
            <div v-if="!$props.order.is_cancelled && order.payment_intent_ID" class="modal-footer">
        <button type="button" class="btn btn-secondary"  v-on:click="refundOrder">Refund Order</button>
      </div>
        </div>
    </div>
</template>

<script>

import swal from 'sweetalert';

export default {
  name: 'CheckoutOrder',
  props: ['order'],
  data() {
    return {
     notes:""
    };
  },
  methods: {

    platformFee(){
      var subtotal = this.getSubTotal()
      const subInPennies = subtotal*100
            const platformFee = Math.round(subInPennies * 0.031+20); // 3.1% +20c
              const stripeFee = Math.round(subInPennies * 0.029 + 30); //2.9%+30c
            const serviceChargeValue = (stripeFee+platformFee)*.01
      return serviceChargeValue.toFixed(2)
    },

    getSubTotal(){
      var subtotal = 0
      if(this.$props.order){
          for (var iter =0;iter<this.$props.order.item_list.length;iter++){
            subtotal += this.getFullItemCost(this.$props.order.item_list[iter])
          }
      }

      return subtotal
    },
    getFullItemCost(menuItem){
      var totalCost = menuItem.cost_with_tax*menuItem.numberOfDrinks;
        // Iterate through the main object
      for (let key in menuItem.additionalInfo) {
        // Iterate through the nested objects (items like bacon, rice, etc.)
        for (let additonalInfoItem in menuItem.additionalInfo[key]) {
          // Add the cost to the total, converting the cost string to a number
          totalCost += parseFloat(menuItem.additionalInfo[key][additonalInfoItem].cost);
        }
      }
      console.log("additional cost: ",totalCost)
      return totalCost
    },
    toDollarAmount(value){
      return (value*.01).toFixed(2)
    },
    refundOrder(){    
      swal({
  title: 'Are you sure you want to refund this order? This is not reversable',
  text: "Refunding an order only returns the subtotal. Platform fees are paid by the customer and not refunded.",
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){

          this.$emit("refundOrderModal",this.$props.order)
          this.$refs.close.click();
      }
    });
  },
  },
};
</script>

<style>
/* styles here */
</style>
